import axios from "axios"
import { AuthAxios } from "./AuthAxios"
import { config } from "../config"

export interface QrSessionPending {
  status: 'pending'
}

export interface QrSessionApproved {
  status: 'approved'
  device_id: string
  access_token: string
  refresh_token: string
  expires_in: number
}

export interface QrSessionTerminal {
  status: 'consumed' | 'expired'
}

export type QrSessionResponse = QrSessionPending | QrSessionApproved | QrSessionTerminal

export const QrSessionApi = {
  async poll(nonce: string): Promise<QrSessionResponse | null> {
    const response = await axios.get<QrSessionResponse>(
      `${config.authority}/api/qr-session/${nonce}`,
      { validateStatus: (status) => status === 200 || status === 410 }
    )

    if (response.status === 410) {
      return { status: 'expired' }
    }

    return response.data
  },

  async transfer(nonce: string, device_id: string): Promise<number> {
    const response = await AuthAxios.post(
      `${config.authority}/api/qr-session/transfer`,
      { nonce, device_id },
      { validateStatus: (s) => [204, 401, 409, 422].includes(s) }
    )

    return response.status
  }
}
